import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box} from 'views/components';
import {Translate} from 'views/module';

const Content = (props) => {
  const careviewItem = props.careviewItem;
  const setEditMode = props.setEditMode;

  const questionTitle = careviewItem.questionData.questionTitle;
  const isRequired = careviewItem.questionData.isRequired;

  return (
    <Stack
    >
      <Box
        sx={{
          '&:hover': {
            cursor: 'pointer',
          },
        }}
        onClick={setEditMode}
      >
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            <Translate
              expression='client.ClientDetail.CareviewSettings.Types.FreeFormText.Question'
            />
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '16px',
            }}
          >
            {questionTitle}
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            <Translate
              expression='client.ClientDetail.CareviewSettings.Types.FreeFormText.RequirdTitle'
            />
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '16px',
            }}
          >
            <Translate
              expression={
                isRequired ?
                  'client.ClientDetail.CareviewSettings.Types.FreeFormText.Enabled' :
                  'client.ClientDetail.CareviewSettings.Types.FreeFormText.Disabled'
              }
            />
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
};

Content.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  setEditMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
